import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import InfoTwoToneIcon from "@mui/icons-material/InfoTwoTone";

import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
} from "@mui/material";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function CustomizedDialogs(props) {
  const { profile_id, host_id } = props;
  console.log(profile_id, host_id);
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [profileinfo, setProfileinfo] = React.useState([]);
  const [hostinfo, setHostinfo] = React.useState([]);
  console.log(profileinfo, hostinfo);

  React.useEffect(() => {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/organizationindividualprofile/${profile_id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
          window.localStorage.setItem("user_access", data.detail);
        } else {
          setProfileinfo(data);
        }
      })
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  React.useEffect(() => {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/organizationindividualhostinfo/${host_id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
          window.localStorage.setItem("user_access", data.detail);
        } else {
          setHostinfo(data);
        }
      })
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  return (
    <>
      <IconButton
        color="primary"
        size="sm"
        title="Info"
        style={{
          padding: "0px",
          color: "lightgreen",
        }}
        onClick={handleClickOpen}
      >
        <InfoTwoToneIcon fontSize="small" color="primary" />
      </IconButton>
      <div>
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          fullWidth
        >
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={handleClose}
          >
            More Informations
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <span>Selected Profile:</span>
            <Grid container spacing={1} marginTop={1} marginLeft={1}>
              <Grid item xs={5} marginLeft={1}>
                <Typography gutterBottom>
                  Name: <strong>{profileinfo.name}</strong>
                </Typography>
              </Grid>
              <Grid item xs={5} marginLeft={1}>
                <Typography gutterBottom>
                  Platform: <strong>{profileinfo.os_type}</strong>
                </Typography>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogContent dividers>
            <span>Selected Hosts:</span>
            <Table>
              <TableHead className="bg-blueGray-100">
                <TableRow>
                  <TableCell align="center">Host Name</TableCell>
                  <TableCell align="center">IP/Dns</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {hostinfo.map((dat) => {
                  return (
                    <>
                      <TableRow hover>
                        <TableCell align="center">{dat.hostname}</TableCell>
                        <TableCell align="center">{dat.ip_dns}</TableCell>
                      </TableRow>
                    </>
                  );
                })}
              </TableBody>
            </Table>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleClose}>
              Close
            </Button>
          </DialogActions>
        </BootstrapDialog>
      </div>
    </>
  );
}